import {combineReducers} from "redux";
import {FIELD_UPDATED, FORM_PROCESSING, SUBSCRIBED_UPDATED} from "./actions";

function deliveryForm(state = {subscribed: {}, data: {}, processing: false}, action) {
    switch (action.type) {
        case FIELD_UPDATED:
            return {...state, data: {...state.data, [action.field]: action.value}};
        case FORM_PROCESSING:
            return {...state, processing: action.processing};
        case SUBSCRIBED_UPDATED:
            return {...state, subscribed: action.subscribed};
        default:
            return state;
    }
}

export const reducers = combineReducers({deliveryForm});


// WEBPACK FOOTER //
// ./src/delivery/reducers.js